import React, { useEffect, useState } from 'react'
import getNewsService from 'services/article/getNews'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import ShareButtonGroup from 'components/shareButtonGroup/common'
import DOMPurify from 'dompurify'
import styles from './mainContent.module.sass'

function Article() {
  const dispatch = useDispatch()
  const [content, setContent] = useState('')
  const { id } = useParams()
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await dispatch(getNewsService({ id: parseInt(id, 10) }))
        setContent(DOMPurify.sanitize(data.content, { ADD_TAGS: ['iframe'], ADD_ATTR: ['allow'] }))
      } catch (error) {
        //
      }
    }
    fetchData()
  }, [dispatch, id])
  return (
    <div className={styles.root}>
      <div className={styles.shareButtonGroup}>
        <ShareButtonGroup articleURL={window.location.href} />
      </div>
      <div
        className={styles.innerHtml}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />

    </div>

  )
}

export default Article
